import * as React from 'react';
import './custom-label.css';

export default function CustomLabel(props) {
  return (
    <p className="custom-label">{props.label}</p>
  );
}
